import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { Navbar } from '../components/Navbar';
import { Footer } from '../components/Footer';
import { ProductCard } from '../components/ProductCard';
import { useData } from '../contexts/DataContext';
import { Search, Filter, Sparkles } from 'lucide-react';
import { CustomizationWizard } from '../components/occasions/CustomizationWizard';
export function ShopPage() {
  const {
    products
  } = useData();
  const [searchTerm, setSearchTerm] = useState('');
  const [categoryFilter, setCategoryFilter] = useState<string>('all');
  const [isCustomizationOpen, setIsCustomizationOpen] = useState(false);
  const filteredProducts = products.filter(product => {
    const matchesSearch = product.name.toLowerCase().includes(searchTerm.toLowerCase());
    const matchesCategory = categoryFilter === 'all' || product.category === categoryFilter;
    return matchesSearch && matchesCategory;
  });
  const categories = ['all', ...Array.from(new Set(products.map(p => p.category)))];
  return <div className="min-h-screen bg-white" data-id="element-2888">
      <Navbar data-id="element-2889" />

      <main className="pt-24 pb-16" data-id="element-2890">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-2891">
          {/* Header */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} className="text-center mb-12" data-id="element-2892">
            <h1 className="text-4xl md:text-5xl font-bold font-serif mb-4" data-id="element-2893">
              Shop Our Collection
            </h1>
            <p className="text-gray-600 text-lg max-w-2xl mx-auto" data-id="element-2894">
              Discover our complete range of beautiful gifts, flowers, and
              balloons
            </p>
          </motion.div>

          {/* Custom Order CTA */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="mb-12" data-id="element-2895">
            <button onClick={() => setIsCustomizationOpen(true)} className="w-full bg-gradient-to-r from-rose-500 to-purple-600 text-white p-6 rounded-2xl shadow-lg hover:shadow-xl transition-all group" data-id="element-2896">
              <div className="flex items-center justify-center gap-3" data-id="element-2897">
                <Sparkles className="w-6 h-6 group-hover:scale-110 transition-transform" data-id="element-2898" />
                <div className="text-left" data-id="element-2899">
                  <h3 className="text-xl font-bold" data-id="element-2900">Create Custom Order</h3>
                  <p className="text-white/90 text-sm" data-id="element-2901">
                    Design your perfect gift with our customization wizard
                  </p>
                </div>
              </div>
            </button>
          </motion.div>

          {/* Filters */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.2
        }} className="mb-8 space-y-4" data-id="element-2902">
            {/* Search */}
            <div className="relative max-w-md" data-id="element-2903">
              <Search className="absolute left-4 top-1/2 -translate-y-1/2 text-gray-400 w-5 h-5" data-id="element-2904" />
              <input type="text" placeholder="Search products..." value={searchTerm} onChange={e => setSearchTerm(e.target.value)} className="w-full pl-12 pr-4 py-3 border border-gray-200 rounded-xl focus:outline-none focus:ring-2 focus:ring-rose-500/20 focus:border-rose-500" data-id="element-2905" />
            </div>

            {/* Category Filter */}
            <div className="flex items-center gap-2 flex-wrap" data-id="element-2906">
              <Filter className="w-5 h-5 text-gray-400" data-id="element-2907" />
              {categories.map(category => <button key={category} onClick={() => setCategoryFilter(category)} className={`px-4 py-2 rounded-full text-sm font-medium transition-all ${categoryFilter === category ? 'bg-rose-500 text-white shadow-md' : 'bg-gray-100 text-gray-700 hover:bg-gray-200'}`} data-id="element-2908">
                  {category === 'all' ? 'All Products' : category.charAt(0).toUpperCase() + category.slice(1)}
                </button>)}
            </div>
          </motion.div>

          {/* Products Grid */}
          <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} transition={{
          delay: 0.3
        }} data-id="element-2909">
            {filteredProducts.length === 0 ? <div className="text-center py-16" data-id="element-2910">
                <p className="text-gray-500 text-lg" data-id="element-2911">
                  No products found matching your criteria
                </p>
              </div> : <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6" data-id="element-2912">
                {filteredProducts.map((product, index) => <motion.div key={product.id} initial={{
              opacity: 0,
              y: 20
            }} animate={{
              opacity: 1,
              y: 0
            }} transition={{
              delay: index * 0.05
            }} data-id="element-2913">
                    <ProductCard product={product} name={product.name} price={product.price} image={product.image} category={product.category} isNew={product.isNew} data-id="element-2914" />
                  </motion.div>)}
              </div>}
          </motion.div>
        </div>
      </main>

      <Footer data-id="element-2915" />

      {/* Customization Wizard Modal */}
      <CustomizationWizard isOpen={isCustomizationOpen} onClose={() => setIsCustomizationOpen(false)} data-id="element-2916" />
    </div>;
}